import createEventSignal from '../core/Signal';

export const [onToggleTasksPanel, dispatchToggleTasksPanel] = createEventSignal<boolean>();
